/* @flow strict */

import * as React from 'react';
import Modal from '/client/src/components/Modal';
import BtnLoader from '/client/src/components/btns/circularProgress/';
import { DefaultContainerContext } from '/client/src/contexts/defaultContainer';
import { PUT } from '/client/src/api';
import { timeerOffModal } from '/client/src/constants/';

import './styles.scss';

type PropsType = {
  isOpen: boolean,
  handleToggleModal: (boolean) => void,
  calendarTheme: string,
  setCalendarTheme: (string) => void
};

class IntegrationsCalendarThemeModal extends React.Component<PropsType> {
  props: PropsType;

  static contextType = DefaultContainerContext;

  state = {
    isLocked: false
  }

  handleClose = (): any => {
    const { handleToggleModal } = this.props;

    handleToggleModal(false);
  };


  handleChangeRadio = (e: any) => {
    this.props.setCalendarTheme(e.target.value);
  }

  handleSave = async (setStatus: (string) => void) => {
    const { isLocked } = this.state;
    const { calendarTheme } = this.props;

    if (isLocked) {
      return;
    }

    this.setState({
      isLocked: true
    }, () => {
      setStatus('loading');
    });

    try {
      const { success } = await PUT('/api/v1/1/merchants/calendar_theme', {
        theme: calendarTheme
      });

      if (success) {
        this.setState({
          isLocked: false
        }, () => {
          setStatus('success');

          this.handleClose();

          this.context.handleShowSystemDialog(true, {
            systemDialogType: 'success',
            systemDialogTitle: 'Great!',
            systemDialogContent: 'Successfully saved'
          });
        });
      }
    } catch (error) {
      this.setState({
        isLocked: false
      }, () => {
        this.context.handleShowSystemDialog(true, {
          systemDialogType: 'error',
          systemDialogTitle: 'Error!',
          systemDialogContent: 'Can\'t save data'
        });

        setStatus('error');
        console.error(error);

        setTimeout(() => {
          setStatus('');
        }, timeerOffModal * 2);
      });
    }
  }


  render(): React.Element {
    const { isOpen, calendarTheme } = this.props;

    return (
      <Modal
        opened={isOpen}
        onClose={this.handleClose}
      >
        <div className="modal-dialog customModal IntegrationsCalendarModal calendar-theme-modal" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Choose a theme for your calendar</h4>
            </div>
            <div className="modal-body">
                <div className="form-group">
                  <div className="row">
                    <label htmlFor="ck_calendar_theme_classic" className="col-xs-4 text-center">
                      <i className="theme-image calendar-theme-classic" />
                      <label className="icheckbox">
                        <input
                          type="radio"
                          id="ck_calendar_theme_classic"
                          value="Classic"
                          name="ko_unique_1"
                          checked={calendarTheme === 'Classic'}
                          onChange={this.handleChangeRadio}
                        />
                        <i className="icheckbox-icon" />
                        <span className="cursor-pointer">Classic</span>
                      </label>
                    </label>

                    <label htmlFor="ck_calendar_theme_dark" className="col-xs-4 text-center">
                      <i className="theme-image calendar-theme-dark" />
                      <label className="icheckbox">
                        <input
                          type="radio"
                          id="ck_calendar_theme_dark"
                          value="Black"
                          name="ko_unique_2"
                          checked={calendarTheme === 'Black'}
                          onChange={this.handleChangeRadio}
                        />
                        <i className="icheckbox-icon" />
                        <span className="cursor-pointer">Black</span>
                      </label>
                    </label>

                    <label htmlFor="ck_calendar_theme_light" className="col-xs-4 text-center">
                      <i className="theme-image calendar-theme-light" />
                      <label className="icheckbox">
                        <input
                          type="radio"
                          id="ck_calendar_theme_light"
                          value="White"
                          name="ko_unique_3"
                          checked={calendarTheme === 'White'}
                          onChange={this.handleChangeRadio}
                        />
                        <i className="icheckbox-icon" />
                        <span className="cursor-pointer">White</span>
                      </label>
                    </label>
                  </div>
                </div>
              <br/>
            </div>

            <div className="modal-footer">
              <button className="btn btn-gray" onClick={this.handleClose}>Close</button>
              <span className="custom-pb-container">
                <BtnLoader
                  label='Save'
                  handleCallBack={(e: SyntheticEvent<HTMLButtonElement>, setStatus: (string) => void) => {
                    this.handleSave(setStatus);
                  }}
                />
              </span>
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}

export default IntegrationsCalendarThemeModal;
